import style from './style.css';
import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import {
  buyWithInstacredLandingRoute,
  offersInstacred,
  bicRevampCategoryViewAllPage,
  loginRoute,
} from '../../../../../alias/homeRoutes';

import { tracker, UserActionType } from '../../../../../tracking';
import { connect } from 'react-redux';
import { isNavMenuRoute } from '../../../../../utils/navBar';
import { generateUrlWithParams } from '../../../../../utils/routeHandler';
import { isMobile } from '../../../../../utils/helper';

function BottomNav({ routeDetails, pageKey, campaignId }) {
  const [activeTab, setActiveTab] = useState('buy');

  useEffect(() => {
    const navPath = isNavMenuRoute();

    if (navPath) {
      setActiveTab(navPath);
    }
  }, [routeDetails]);

  const changeTab = (selectedTab) => {
    setActiveTab(selectedTab);
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      `bic_bottom_navbar_${selectedTab.split('/')[1]}`,
      pageKey,
      {
        campaign_id: campaignId,
      },
    );

    switch (selectedTab) {
      case buyWithInstacredLandingRoute.path:
        route(
          generateUrlWithParams(buyWithInstacredLandingRoute.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case offersInstacred.path:
        route(
          generateUrlWithParams(offersInstacred.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case bicRevampCategoryViewAllPage.path:
        route(
          generateUrlWithParams(bicRevampCategoryViewAllPage.path, {
            utm_campaign: campaignId,
          }),
        );
        return;

      case loginRoute.path:
        route(
          generateUrlWithParams(loginRoute.path, { utm_campaign: campaignId }),
        );
        return;
    }
  };

  return (
    <div
      className={`${
        isMobile
          ? style.bottomNavContainerVisible
          : style.bottomNavContainerHidden
      }`}>
      <div className={`${style.tabWrapper}`}>
        <div
          onClick={() => changeTab(buyWithInstacredLandingRoute.path)}
          className={`${style.tab} ${
            activeTab === buyWithInstacredLandingRoute.path
              ? style.activeTab
              : ''
          }`}>
          <div>
            <svg
              width='26'
              height='24'
              viewBox='0 0 26 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M12.8749 10.5028L21.5004 6.92476C21.3525 6.77576 21.1853 6.64276 20.9826 6.54976L13.6866 3.17576C13.1749 2.94076 12.575 2.94076 12.0633 3.17576L4.76725 6.54976C4.56459 6.64276 4.39739 6.77576 4.24944 6.92476L12.8749 10.5028ZM12.1149 11.827L3.75493 8.35896V16.088C3.74987 16.729 4.13899 17.317 4.75813 17.606L12.0541 20.979C12.064 20.9836 12.0744 20.9866 12.0849 20.9897C12.0949 20.9926 12.105 20.9956 12.1149 21V11.827ZM13.6349 20.997V11.827L21.9949 8.35896V16.097C21.9949 16.736 21.6028 17.321 20.9826 17.606L13.6866 20.979C13.6774 20.9835 13.6676 20.9864 13.6577 20.9894C13.6501 20.9916 13.6424 20.9939 13.6349 20.997Z'
                fill='black'
                fill-opacity='0.4'
              />
              <mask
                id='mask0_11_4256'
                style='mask-type:alpha'
                maskUnits='userSpaceOnUse'
                x='3'
                y='2'
                width='19'
                height='19'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M12.8749 10.5028L21.5004 6.92476C21.3525 6.77576 21.1853 6.64276 20.9826 6.54976L13.6866 3.17576C13.1749 2.94076 12.575 2.94076 12.0633 3.17576L4.76725 6.54976C4.56459 6.64276 4.39739 6.77576 4.24944 6.92476L12.8749 10.5028ZM12.1149 11.827L3.75493 8.35896V16.088C3.74987 16.729 4.13899 17.317 4.75813 17.606L12.0541 20.979C12.064 20.9836 12.0744 20.9866 12.0849 20.9897C12.0949 20.9926 12.105 20.9956 12.1149 21V11.827ZM13.6349 20.997V11.827L21.9949 8.35896V16.097C21.9949 16.736 21.6028 17.321 20.9826 17.606L13.6866 20.979C13.6774 20.9835 13.6676 20.9864 13.6577 20.9894C13.6501 20.9916 13.6424 20.9939 13.6349 20.997Z'
                  fill='white'
                />
              </mask>
              <g mask='url(#mask0_11_4256)' />
            </svg>
          </div>
          <div
            id='cardlessEmi-tab'
            className={`${
              activeTab === buyWithInstacredLandingRoute.path
                ? style.highlightText
                : 'text60 text-center bold-500'
            }`}>
            Home
          </div>
        </div>
        <div
          onClick={() => changeTab(offersInstacred.path)}
          className={`${style.tab}  ${
            activeTab === offersInstacred.path ? style.activeTab : ''
          }`}>
          <div>
            <svg
              width='25'
              height='24'
              viewBox='0 0 25 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M13.625 19H18.125V15H13.625V19ZM7.125 19H11.625V15H7.125V19ZM5.625 9.2C5.625 9.117 5.638 9.05 5.651 9H8.768H11.625V13H5.651C5.638 12.95 5.625 12.883 5.625 12.8V9.2ZM7.625 6C7.625 5.448 8.138 5 8.768 5C10.025 5 10.795 6.09 11.219 7H8.768C8.138 7 7.625 6.552 7.625 6ZM16.482 5C17.112 5 17.625 5.448 17.625 6C17.625 6.552 17.112 7 16.482 7H14.025C14.445 6.09 15.213 5 16.482 5ZM19.625 9.2V12.8C19.625 12.883 19.612 12.95 19.599 13H13.625V9H16.482H19.599C19.612 9.05 19.625 9.117 19.625 9.2ZM19.825 7H19.432C19.55 6.686 19.625 6.353 19.625 6C19.625 4.346 18.215 3 16.482 3C14.56 3 13.354 4.199 12.625 5.397C11.896 4.199 10.69 3 8.768 3C7.035 3 5.625 4.346 5.625 6C5.625 6.353 5.701 6.686 5.818 7H5.425C4.416 7 3.625 7.967 3.625 9.2V12.8C3.625 13.907 4.265 14.793 5.125 14.964V19.333C5.125 20.252 5.938 21 6.937 21H18.312C19.312 21 20.125 20.252 20.125 19.333V14.964C20.985 14.793 21.625 13.907 21.625 12.8V9.2C21.625 7.967 20.834 7 19.825 7Z'
                fill='black'
                fill-opacity='0.4'
              />
              <mask
                id='mask0_25_1381'
                style='mask-type:alpha'
                maskUnits='userSpaceOnUse'
                x='3'
                y='3'
                width='19'
                height='18'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M13.625 19H18.125V15H13.625V19ZM7.125 19H11.625V15H7.125V19ZM5.625 9.2C5.625 9.117 5.638 9.05 5.651 9H8.768H11.625V13H5.651C5.638 12.95 5.625 12.883 5.625 12.8V9.2ZM7.625 6C7.625 5.448 8.138 5 8.768 5C10.025 5 10.795 6.09 11.219 7H8.768C8.138 7 7.625 6.552 7.625 6ZM16.482 5C17.112 5 17.625 5.448 17.625 6C17.625 6.552 17.112 7 16.482 7H14.025C14.445 6.09 15.213 5 16.482 5ZM19.625 9.2V12.8C19.625 12.883 19.612 12.95 19.599 13H13.625V9H16.482H19.599C19.612 9.05 19.625 9.117 19.625 9.2ZM19.825 7H19.432C19.55 6.686 19.625 6.353 19.625 6C19.625 4.346 18.215 3 16.482 3C14.56 3 13.354 4.199 12.625 5.397C11.896 4.199 10.69 3 8.768 3C7.035 3 5.625 4.346 5.625 6C5.625 6.353 5.701 6.686 5.818 7H5.425C4.416 7 3.625 7.967 3.625 9.2V12.8C3.625 13.907 4.265 14.793 5.125 14.964V19.333C5.125 20.252 5.938 21 6.937 21H18.312C19.312 21 20.125 20.252 20.125 19.333V14.964C20.985 14.793 21.625 13.907 21.625 12.8V9.2C21.625 7.967 20.834 7 19.825 7Z'
                  fill='white'
                />
              </mask>
              <g mask='url(#mask0_25_1381)' />
            </svg>
          </div>
          <div
            className={`${
              activeTab === offersInstacred.path
                ? style.highlightText
                : 'text60 bold-500'
            }`}>
            Offers
          </div>
        </div>
        <div
          onClick={() => changeTab(bicRevampCategoryViewAllPage.path)}
          className={`${style.tab}  ${
            activeTab === bicRevampCategoryViewAllPage.path
              ? style.activeTab
              : ''
          }`}>
          <div>
            <svg
              width='25'
              height='24'
              viewBox='0 0 25 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M17.2638 18.3184C17.0918 17.8854 16.8478 17.5074 16.6338 17.1844C16.5258 17.0224 16.4148 16.8574 16.3178 16.6874C15.9288 16.0114 16.0628 15.7374 16.6938 14.6804L16.7958 14.5074C17.3068 13.6464 17.3348 12.8204 17.3608 12.0924C17.3728 11.7344 17.3848 11.3974 17.4538 11.0804C17.6148 10.3484 19.1618 10.1534 20.1208 10.0384C20.2818 10.6674 20.3748 11.3224 20.3748 12.0004C20.3748 14.5694 19.1528 16.8534 17.2638 18.3184ZM5.33676 15.7994C5.97276 15.9614 6.66176 16.0734 7.36276 16.0734C8.44276 16.0734 9.54576 15.8094 10.4998 15.0624C12.2158 13.7204 12.2158 12.0044 12.2158 10.6244C12.2158 9.73237 12.2158 8.96337 12.5878 8.28037C12.7878 7.91437 13.2138 7.66037 13.7068 7.36537C14.0088 7.18437 14.3218 6.99837 14.6218 6.76237C15.2648 6.25937 15.7428 5.61237 16.0388 4.89637C17.4388 5.62137 18.5988 6.74437 19.3648 8.11937C17.9368 8.31737 15.9098 8.78537 15.5008 10.6524C15.3928 11.1464 15.3758 11.6114 15.3628 12.0224C15.3418 12.6054 15.3258 13.0664 15.0758 13.4884L14.9758 13.6564C14.3288 14.7394 13.5968 15.9674 14.5838 17.6844C14.7028 17.8924 14.8358 18.0924 14.9668 18.2914C15.3108 18.8074 15.4798 19.0924 15.4808 19.3724C14.5258 19.7764 13.4758 20.0004 12.3748 20.0004C9.33776 20.0004 6.69176 18.2984 5.33676 15.7994ZM12.3748 4.00037C12.9908 4.00037 13.5858 4.07637 14.1618 4.20837C13.9928 4.58037 13.7318 4.91937 13.3878 5.18837C13.1698 5.36037 12.9248 5.50337 12.6818 5.64837C12.0308 6.03637 11.2938 6.47637 10.8318 7.32237C10.2158 8.45237 10.2158 9.60637 10.2158 10.6244C10.2158 11.9794 10.1718 12.7804 9.26776 13.4874C7.89876 14.5604 5.80376 13.9614 4.50776 13.4164C4.42576 12.9554 4.37476 12.4834 4.37476 12.0004C4.37476 7.58937 7.96376 4.00037 12.3748 4.00037ZM12.3748 2.00037C6.86076 2.00037 2.37476 6.48637 2.37476 12.0004C2.37476 17.5134 6.86076 22.0004 12.3748 22.0004C17.8888 22.0004 22.3748 17.5134 22.3748 12.0004C22.3748 6.48637 17.8888 2.00037 12.3748 2.00037Z'
                fill='black'
                fill-opacity='0.4'
              />
              <mask
                id='mask0_25_1384'
                style='mask-type:alpha'
                maskUnits='userSpaceOnUse'
                x='2'
                y='2'
                width='21'
                height='21'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M17.2638 18.3184C17.0918 17.8854 16.8478 17.5074 16.6338 17.1844C16.5258 17.0224 16.4148 16.8574 16.3178 16.6874C15.9288 16.0114 16.0628 15.7374 16.6938 14.6804L16.7958 14.5074C17.3068 13.6464 17.3348 12.8204 17.3608 12.0924C17.3728 11.7344 17.3848 11.3974 17.4538 11.0804C17.6148 10.3484 19.1618 10.1534 20.1208 10.0384C20.2818 10.6674 20.3748 11.3224 20.3748 12.0004C20.3748 14.5694 19.1528 16.8534 17.2638 18.3184ZM5.33676 15.7994C5.97276 15.9614 6.66176 16.0734 7.36276 16.0734C8.44276 16.0734 9.54576 15.8094 10.4998 15.0624C12.2158 13.7204 12.2158 12.0044 12.2158 10.6244C12.2158 9.73237 12.2158 8.96337 12.5878 8.28037C12.7878 7.91437 13.2138 7.66037 13.7068 7.36537C14.0088 7.18437 14.3218 6.99837 14.6218 6.76237C15.2648 6.25937 15.7428 5.61237 16.0388 4.89637C17.4388 5.62137 18.5988 6.74437 19.3648 8.11937C17.9368 8.31737 15.9098 8.78537 15.5008 10.6524C15.3928 11.1464 15.3758 11.6114 15.3628 12.0224C15.3418 12.6054 15.3258 13.0664 15.0758 13.4884L14.9758 13.6564C14.3288 14.7394 13.5968 15.9674 14.5838 17.6844C14.7028 17.8924 14.8358 18.0924 14.9668 18.2914C15.3108 18.8074 15.4798 19.0924 15.4808 19.3724C14.5258 19.7764 13.4758 20.0004 12.3748 20.0004C9.33776 20.0004 6.69176 18.2984 5.33676 15.7994ZM12.3748 4.00037C12.9908 4.00037 13.5858 4.07637 14.1618 4.20837C13.9928 4.58037 13.7318 4.91937 13.3878 5.18837C13.1698 5.36037 12.9248 5.50337 12.6818 5.64837C12.0308 6.03637 11.2938 6.47637 10.8318 7.32237C10.2158 8.45237 10.2158 9.60637 10.2158 10.6244C10.2158 11.9794 10.1718 12.7804 9.26776 13.4874C7.89876 14.5604 5.80376 13.9614 4.50776 13.4164C4.42576 12.9554 4.37476 12.4834 4.37476 12.0004C4.37476 7.58937 7.96376 4.00037 12.3748 4.00037ZM12.3748 2.00037C6.86076 2.00037 2.37476 6.48637 2.37476 12.0004C2.37476 17.5134 6.86076 22.0004 12.3748 22.0004C17.8888 22.0004 22.3748 17.5134 22.3748 12.0004C22.3748 6.48637 17.8888 2.00037 12.3748 2.00037Z'
                  fill='white'
                />
              </mask>
              <g mask='url(#mask0_25_1384)' />
            </svg>
          </div>
          <div
            className={`${
              activeTab === bicRevampCategoryViewAllPage.path
                ? style.highlightText
                : 'text60 bold-500'
            }`}>
            Category
          </div>
        </div>
        <div
          onClick={() => changeTab(loginRoute.path)}
          className={`${style.tab}  ${
            activeTab === loginRoute.path ? style.activeTab : ''
          }`}>
          <div>
            <svg
              width='26'
              height='24'
              viewBox='0 0 26 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M20.2183 20C20.2183 20.552 19.7653 21 19.205 21C18.6446 21 18.1916 20.552 18.1916 20C18.1916 17.243 15.9187 15 13.125 15C10.3312 15 8.05828 17.243 8.05828 20C8.05828 20.552 7.60532 21 7.04495 21C6.48458 21 6.03162 20.552 6.03162 20C6.03162 16.14 9.2145 13 13.125 13C17.0354 13 20.2183 16.14 20.2183 20ZM13.125 5C14.2427 5 15.1516 5.897 15.1516 7C15.1516 8.103 14.2427 9 13.125 9C12.0072 9 11.0983 8.103 11.0983 7C11.0983 5.897 12.0072 5 13.125 5ZM13.125 11C15.3604 11 17.1783 9.206 17.1783 7C17.1783 4.794 15.3604 3 13.125 3C10.8895 3 9.07162 4.794 9.07162 7C9.07162 9.206 10.8895 11 13.125 11Z'
                fill='black'
                fill-opacity='0.4'
              />
            </svg>
          </div>
          <div
            className={`${
              activeTab === loginRoute.path
                ? style.highlightText
                : 'text60 bold-500 '
            }`}>
            My Account
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ config, buyWithInstacred }) => {
  const { pageKey, routeDetails } = config;
  const { home } = buyWithInstacred;
  const { campaignId } = home;

  return {
    pageKey,
    campaignId,
    routeDetails,
  };
};
export default connect(mapStateToProps)(BottomNav);



// WEBPACK FOOTER //
// ./components/partial/container/bicRevampContainer/bottomNav/index.js